import React from "react";

import { SCHOOL_COLORS } from "@/providers/maps/constants";
import { SchoolLevelType } from "@/providers/store/api/schools/schools.interface";
import { sortSchoolLevelTypeStrings } from "@/shared/utils/school-level-display.utils";

const LEVEL_BADGE: Record<string, { short: string; color: string }> = {
  [SchoolLevelType.ELEMENTARY]: { short: "ES", color: SCHOOL_COLORS.ELEMENTARY },
  [SchoolLevelType.MIDDLE]: { short: "MS", color: SCHOOL_COLORS.MIDDLE },
  [SchoolLevelType.HIGH]: { short: "HS", color: SCHOOL_COLORS.HIGH },
  [SchoolLevelType.K8]: { short: "K8", color: SCHOOL_COLORS.K8 },
};

interface SchoolClusterSchoolTypeBadgesProps {
  schoolTypes: string[];
}

const SchoolClusterSchoolTypeBadgesComponent: React.FC<SchoolClusterSchoolTypeBadgesProps> = ({
  schoolTypes,
}) => {
  if (!schoolTypes.length) return null;

  const orderedTypes = sortSchoolLevelTypeStrings(schoolTypes);

  return (
    <div className="flex shrink-0 items-center gap-1">
      {orderedTypes.map((type) => {
        const badge = LEVEL_BADGE[type];
        if (!badge) return null;

        return (
          <span
            key={type}
            aria-label={badge.short}
            className="h-4 w-4 shrink-0 rounded-sm"
            style={{ backgroundColor: badge.color }}
          />
        );
      })}
    </div>
  );
};

export const SchoolClusterSchoolTypeBadges = React.memo(
  SchoolClusterSchoolTypeBadgesComponent,
);
